/**
 * Estilos y temas visuales para el banner de permisos de notificación.
 * Alineado con la paleta de tarjetas y modo oscuro (#121e2d) de Support Engine.
 */

export const BANNER_THEME = {
  accentDenied: '#f59e0b',
  accentDefault: '#2563eb'
};

export const getBannerTheme = (isDark = false, isDenied = false) => {
  if (isDark) {
    return {
      bannerBg: '#121e2d',
      bannerBorder: '#233142',
      borderLeft: isDenied ? `4px solid ${BANNER_THEME.accentDenied}` : `4px solid ${BANNER_THEME.accentDefault}`,
      iconBg: isDenied ? 'rgba(245, 158, 11, 0.18)' : 'rgba(37, 99, 235, 0.18)',
      iconColor: isDenied ? '#fbbf24' : '#60a5fa',
      titleColor: '#f8fafc',
      textColor: '#94a3b8',
      badgeBg: isDenied ? 'rgba(239, 68, 68, 0.18)' : 'rgba(245, 158, 11, 0.18)',
      badgeColor: isDenied ? '#f87171' : '#fbbf24',
      badgeBorder: isDenied ? 'rgba(239, 68, 68, 0.3)' : 'rgba(245, 158, 11, 0.3)'
    };
  }

  return {
    bannerBg: '#ffffff',
    bannerBorder: '#e2e8f0',
    borderLeft: isDenied ? `4px solid ${BANNER_THEME.accentDenied}` : `4px solid ${BANNER_THEME.accentDefault}`,
    iconBg: isDenied ? '#fef3c7' : '#eff6ff',
    iconColor: isDenied ? '#d97706' : '#2563eb',
    titleColor: '#0f172a',
    textColor: '#64748b',
    badgeBg: isDenied ? '#fee2e2' : '#fef3c7',
    badgeColor: isDenied ? '#b91c1c' : '#b45309',
    badgeBorder: isDenied ? '#fca5a5' : '#fde68a'
  };
};
